import React from 'react';
import FormAfiliado from '../../Afiliado/Components/FormAfiliado';

const CadastroAfiliado = (props) => {
  return (<FormAfiliado />);
};

export default CadastroAfiliado;
